module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_0.d1fecd99.png";